
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hI6CC", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $af65b479e9aa4397$export$7b3d03c2fa269586; });

var $7VQPk = parcelRequire("7VQPk");

var $72aQB = parcelRequire("72aQB");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $6iKF0 = parcelRequire("6iKF0");

var $gsqLc = parcelRequire("gsqLc");
const $af65b479e9aa4397$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleOnError = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            action: 'failed',
            eventType: 'track',
            actionSubject: 'SoftwareRovoStartPage',
            source: 'SoftwareRovoStartPage',
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gsqLc.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $72aQB.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("72aQB", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $154413073beb82d2$export$89c9d15d38180eeb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $5Ntyw = parcelRequire("5Ntyw");

var $lact3 = parcelRequire("lact3");

var $3riD8 = parcelRequire("3riD8");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $4weTV = parcelRequire("4weTV");

var $6VYIX = parcelRequire("6VYIX");
const $154413073beb82d2$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $1oC0p.useState)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    const adminBaseUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return 'https://admin.atlassian.com';
        return (0, $lact3.isProduction)() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $1oC0p.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'softwareRovoStartPage',
            source: 'softwareRovoStartPage',
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $1oC0p.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error('Get account/orgs call failed');
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $1oC0p.useCallback)(async ()=>{
        const productsUrl = (0, $lact3.isProduction)() ? 'https://rovo.atlassian.com' : 'https://home.stg.atlassian.com/rovo';
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error('Get account/products call failed');
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes('rovo.ondemand'));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4weTV.LoginContactSales), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VYIX.LoadingSpinner), {})
    });
};

});
parcelRegister("4weTV", function(module, exports) {
$parcel$export(module.exports, "LoginContactSales", function () { return $00bb124a426bfcbf$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $6A2DX = parcelRequire("6A2DX");

var $bMxrA = parcelRequire("bMxrA");
var $9jghN = parcelRequire("9jghN");
var $7SWbn = parcelRequire("7SWbn");
var $6L4Qq = parcelRequire("6L4Qq");
var $1xo8q = parcelRequire("1xo8q");

var $lmQGF = parcelRequire("lmQGF");

var $8IYGL = parcelRequire("8IYGL");

var $8AXar = parcelRequire("8AXar");

var $iPPTB = parcelRequire("iPPTB");

var $lact3 = parcelRequire("lact3");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $cxI2Y = parcelRequire("cxI2Y");
const $00bb124a426bfcbf$var$elevatedContainerInnerStyles = (0, $1xo8q.xcss)({
    textAlign: 'center',
    paddingBlockStart: 'space.500'
});
const $00bb124a426bfcbf$var$bodyTextStyles = (0, $1xo8q.xcss)({
    paddingBlockStart: 'space.100'
});
const $00bb124a426bfcbf$var$loginButtonStyles = (0, $1xo8q.xcss)({
    paddingBlockStart: 'space.400',
    paddingBlockEnd: 'space.400',
    paddingInlineStart: 'space.800',
    paddingInlineEnd: 'space.800'
});
const $00bb124a426bfcbf$var$contactAtlassianStyles = (0, $1xo8q.xcss)({
    justifyContent: 'center'
});
const $00bb124a426bfcbf$var$relative = null;
const $00bb124a426bfcbf$var$whiteBackground = null;
const $00bb124a426bfcbf$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        analyticsClient && createAnalyticsEvent({
            action: 'clicked',
            actionSubject: buttonName,
            actionSubjectId: 'softwareRovoStartPageTemplate',
            attributes: {
                source: 'loginContactSalesScreen'
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('loginButton'), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSalesLink'), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return 'id.atlassian.com/';
        return (0, $lact3.isProduction)() ? 'https://id.atlassian.com/' : 'https://id.stg.internal.atlassian.com/';
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            "aria-label": 'Contact Atlassian Page',
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $8AQXb.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $7VQPk.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
            xcss: $00bb124a426bfcbf$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $8AQXb.messages).rovoGetStarted,
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cxI2Y.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                    xcss: $00bb124a426bfcbf$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6L4Qq.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $8AQXb.messages).rovoBodyText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                    xcss: $00bb124a426bfcbf$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $8AQXb.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9jghN.default), {
                    space: "space.100",
                    xcss: $00bb124a426bfcbf$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $8AQXb.messages).dontHaveAccountText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dTJrO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1e3aa5f77a45f5e$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $fr57R = parcelRequire("fr57R");

var $7t0tI = parcelRequire("7t0tI");
var $a1e3aa5f77a45f5e$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $a1e3aa5f77a45f5e$var$levelMap = {
    h900: 'h1',
    h800: 'h1',
    h700: 'h2',
    h600: 'h3',
    h500: 'h4',
    h400: 'h5',
    h300: 'h6',
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: 'div',
    h100: 'div'
};
var $a1e3aa5f77a45f5e$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $a1e3aa5f77a45f5e$var$h900Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $a1e3aa5f77a45f5e$var$h800Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $a1e3aa5f77a45f5e$var$h700Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $a1e3aa5f77a45f5e$var$h600Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $a1e3aa5f77a45f5e$var$h500Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $a1e3aa5f77a45f5e$var$h400Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h300Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: 'uppercase'
});
var $a1e3aa5f77a45f5e$var$h200Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h100Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $a1e3aa5f77a45f5e$var$subtlestStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $a1e3aa5f77a45f5e$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    var _useHeading = (0, $69vmd.useHeading)($a1e3aa5f77a45f5e$var$levelMap[level]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === 'h200' || level === 'h100';
    var needsAriaRole = Markup === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $a1e3aa5f77a45f5e$var$headingResetStyles,
            level === 'h100' && $a1e3aa5f77a45f5e$var$h100Styles,
            level === 'h200' && $a1e3aa5f77a45f5e$var$h200Styles,
            level === 'h300' && $a1e3aa5f77a45f5e$var$h300Styles,
            level === 'h400' && $a1e3aa5f77a45f5e$var$h400Styles,
            level === 'h500' && $a1e3aa5f77a45f5e$var$h500Styles,
            level === 'h600' && $a1e3aa5f77a45f5e$var$h600Styles,
            level === 'h700' && $a1e3aa5f77a45f5e$var$h700Styles,
            level === 'h800' && $a1e3aa5f77a45f5e$var$h800Styles,
            level === 'h900' && $a1e3aa5f77a45f5e$var$h900Styles,
            color === 'inverse' && $a1e3aa5f77a45f5e$var$inverseStyles,
            color === 'default' && isSubtleHeading && $a1e3aa5f77a45f5e$var$subtlestStyles
        ]
    }, children);
};
var $a1e3aa5f77a45f5e$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $gnQ3X.default)(_ref2, $a1e3aa5f77a45f5e$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)($a1e3aa5f77a45f5e$var$Heading, (0, $c9bqK.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)((0, $fr57R.default), (0, $c9bqK.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("69vmd", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $47abe8463fa9d1c8$export$97a37b1befbbf9b1; });
$parcel$export(module.exports, "default", function () { return $47abe8463fa9d1c8$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $47abe8463fa9d1c8$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($47abe8463fa9d1c8$var$HeadingLevelContext);
};
var $47abe8463fa9d1c8$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $47abe8463fa9d1c8$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($47abe8463fa9d1c8$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $47abe8463fa9d1c8$export$2e2bcd8739ae039 = $47abe8463fa9d1c8$var$HeadingLevelContextProvider;

});

parcelRegister("fr57R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b3cd5a87ca909983$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $7t0tI = parcelRequire("7t0tI");
var $b3cd5a87ca909983$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $b3cd5a87ca909983$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: 'normal',
    marginBlock: 0,
    textTransform: 'none'
});
var $b3cd5a87ca909983$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $b3cd5a87ca909983$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $69vmd.useHeading)($b3cd5a87ca909983$var$sizeTagMap[localSize]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $b3cd5a87ca909983$var$headingResetStyles,
            localSize && $b3cd5a87ca909983$var$headingSizeStylesMap[localSize],
            color === 'inverse' && $b3cd5a87ca909983$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $b3cd5a87ca909983$var$headingSizeStylesMap = {
    xxlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    large: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    medium: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    small: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xxsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    })
};
var /**
 * @codegenEnd
 */ $b3cd5a87ca909983$export$2e2bcd8739ae039 = $b3cd5a87ca909983$var$Heading;

});


parcelRegister("bMxrA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $893e1ea6b61a27b2$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jN4m6 = parcelRequire("jN4m6");

var $1xo8q = parcelRequire("1xo8q");

var $d3wYX = parcelRequire("d3wYX");
var $893e1ea6b61a27b2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $893e1ea6b61a27b2$var$_excluded2 = [
    "className"
];
var $893e1ea6b61a27b2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $893e1ea6b61a27b2$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $893e1ea6b61a27b2$var$_excluded2);
    var className = xcss && (0, $1xo8q.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $893e1ea6b61a27b2$var$baseStyles,
            backgroundColor && (0, $jN4m6.backgroundColorStylesMap)[backgroundColor],
            (0, $jN4m6.isSurfaceColorToken)(backgroundColor) && (0, $jN4m6.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $jN4m6.paddingStylesMap).padding[padding],
            paddingBlock && (0, $jN4m6.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $jN4m6.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $jN4m6.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $jN4m6.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $jN4m6.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $jN4m6.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $d3wYX.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $893e1ea6b61a27b2$export$2e2bcd8739ae039 = $893e1ea6b61a27b2$export$e71c4d32a2263218;
var $893e1ea6b61a27b2$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("d3wYX", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $981523bff8151925$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $981523bff8151925$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $981523bff8151925$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $981523bff8151925$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($981523bff8151925$export$1ca2a26fecb070ae);
};
$981523bff8151925$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("9jghN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c72857c82292085$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1xo8q = parcelRequire("1xo8q");

var $1zgVm = parcelRequire("1zgVm");
var $6c72857c82292085$var$flexGrowMap = {
    hug: (0, $1xo8q.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1xo8q.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $6c72857c82292085$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $6c72857c82292085$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $6c72857c82292085$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $6c72857c82292085$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($6c72857c82292085$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $3dJ4i.jsx)((0, $1zgVm.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $6c72857c82292085$var$flexGrowMap[grow]
        ].concat((0, $lFOXD.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$6c72857c82292085$var$Inline.displayName = 'Inline';
var $6c72857c82292085$export$2e2bcd8739ae039 = $6c72857c82292085$var$Inline;

});
parcelRegister("1zgVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12463018f9c6748c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jN4m6 = parcelRequire("jN4m6");

var $1xo8q = parcelRequire("1xo8q");
var $12463018f9c6748c$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $12463018f9c6748c$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $12463018f9c6748c$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $12463018f9c6748c$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $12463018f9c6748c$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $12463018f9c6748c$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $1xo8q.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        css: [
            $12463018f9c6748c$var$baseStyles,
            gap && (0, $jN4m6.spaceStylesMap).gap[gap],
            columnGap && (0, $jN4m6.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $jN4m6.spaceStylesMap).rowGap[rowGap],
            alignItems && $12463018f9c6748c$var$alignItemsMap[alignItems],
            direction && $12463018f9c6748c$var$flexDirectionMap[direction],
            justifyContent && $12463018f9c6748c$var$justifyContentMap[justifyContent],
            wrap && $12463018f9c6748c$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$12463018f9c6748c$var$Flex.displayName = 'Flex';
var $12463018f9c6748c$export$2e2bcd8739ae039 = $12463018f9c6748c$var$Flex;

});


parcelRegister("7SWbn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5bdab55f379ae074$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1xo8q = parcelRequire("1xo8q");

var $1zgVm = parcelRequire("1zgVm");
var $5bdab55f379ae074$var$flexGrowMap = {
    hug: (0, $1xo8q.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1xo8q.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $5bdab55f379ae074$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    return (0, $3dJ4i.jsx)((0, $1zgVm.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $5bdab55f379ae074$var$flexGrowMap[grow]
        ].concat((0, $lFOXD.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$5bdab55f379ae074$var$Stack.displayName = 'Stack';
var $5bdab55f379ae074$export$2e2bcd8739ae039 = $5bdab55f379ae074$var$Stack;

});

parcelRegister("6L4Qq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ebae3e62029ece2$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $jN4m6 = parcelRequire("jN4m6");

var $d3wYX = parcelRequire("d3wYX");
var $4ebae3e62029ece2$var$_excluded = [
    "children"
];
function $4ebae3e62029ece2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ebae3e62029ece2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ebae3e62029ece2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ebae3e62029ece2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4ebae3e62029ece2$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $4ebae3e62029ece2$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0
});
var $4ebae3e62029ece2$var$variantStyles = $4ebae3e62029ece2$var$_objectSpread($4ebae3e62029ece2$var$_objectSpread({}, (0, $jN4m6.bodyTextStylesMap)), (0, $jN4m6.uiTextStylesMap));
var $4ebae3e62029ece2$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: 'bold'
});
var $4ebae3e62029ece2$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $4ebae3e62029ece2$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $4ebae3e62029ece2$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $4ebae3e62029ece2$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $4ebae3e62029ece2$var$useColor = function useColor(colorProp) {
    var surface = (0, $d3wYX.useSurface)();
    var inverseTextColor = (0, $jN4m6.inverseColorMap)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $4ebae3e62029ece2$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $4ebae3e62029ece2$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($4ebae3e62029ece2$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $4ebae3e62029ece2$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $gnQ3X.default)(_ref, $4ebae3e62029ece2$var$_excluded);
    var asElement = props.as, _props$color = props.color, colorProp = _props$color === void 0 ? 'color.text' : _props$color, textAlign = props.textAlign, testId = props.testId, id = props.id, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body' : _props$variant, weight = props.weight;
    // body variants -> p
    // ui variants -> span
    var Component = asElement || (variant.includes('body') ? 'p' : 'span');
    (0, $lmxXn.default)($4ebae3e62029ece2$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    // Remove the ability to bypass typescript errors for maxLines
    var maxLines;
    if ('maxLines' in props && variant.includes('body')) maxLines = props.maxLines;
    var color = $4ebae3e62029ece2$var$useColor(colorProp);
    var isWrapped = $4ebae3e62029ece2$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, children);
    var component = (0, $3dJ4i.jsx)(Component, {
        css: [
            $4ebae3e62029ece2$var$resetStyles,
            variant && $4ebae3e62029ece2$var$variantStyles[variant],
            color && (0, $jN4m6.textColorStylesMap)[color],
            maxLines && $4ebae3e62029ece2$var$truncationStyles,
            maxLines === 1 && $4ebae3e62029ece2$var$wordBreakMap.breakAll,
            textAlign && $4ebae3e62029ece2$var$textAlignMap[textAlign],
            weight && (0, $jN4m6.fontWeightStylesMap)[weight],
            asElement === 'em' && $4ebae3e62029ece2$var$emStyles,
            asElement === 'strong' && $4ebae3e62029ece2$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)($4ebae3e62029ece2$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $4ebae3e62029ece2$export$2e2bcd8739ae039 = $4ebae3e62029ece2$var$Text;

});

parcelRegister("8IYGL", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return $37a3584e5be26d24$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
const $37a3584e5be26d24$var$textStyle = null;
const $37a3584e5be26d24$var$inViewTextStyle = null;
const $37a3584e5be26d24$var$underlineStyle = null;
const $37a3584e5be26d24$var$inViewUnderlineStyle = null;
const $37a3584e5be26d24$var$hiddenText = null;
const $37a3584e5be26d24$var$visibleText = null;
const $37a3584e5be26d24$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $6ZVlx.default)(fontWeight.from),
            "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
                },
                children: text ?? children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text ?? children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $6ZVlx.default)(underlineInset),
                    "--_p0j3r4": (0, $6ZVlx.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});

parcelRegister("8AXar", function(module, exports) {
$parcel$export(module.exports, "SignupBackgroundLayout", function () { return $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790; });
/* signup-background-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5YGzb = parcelRequire("5YGzb");
const $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790 = ({ ProductLogo: ProductLogo, children: children, theme: theme })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulp10yn _6a6z1h6o _2z051mfv _1itkuprl _bfhkvuon _1lrw10hx _ouxlbbky _12vemgnk _1tke1kxc _ca0q12am _u5f3idpf _n3td53f4 _19bvidpf _v5641i9m _9szs1kz8",
            theme === 'yellow' && "_1itkhe6p",
            theme === 'green' && "_1itkiyjd"
        ]),
        children: [
            ProductLogo,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkvuon _2rko1crf _vchh1ntv _syazazsu _1e0c1txw _2lx21bp4 _ect4b1j9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f13pj _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _1bsb1kdj _scbp1jkq _oqic1ylp _1rmjys9h _cjbt1ylp _pnmbys9h _19451lk4"
                    ]),
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                appearance: "neutral",
                size: "small",
                testId: "atlassian-logo",
                label: "Atlassian logo"
            })
        ]
    });
};
const $3bb8ea39c6cdcf07$var$containerStyles = null;
const $3bb8ea39c6cdcf07$var$yellowThemeCss = null;
const $3bb8ea39c6cdcf07$var$greenThemeCss = null;
const $3bb8ea39c6cdcf07$var$formWrapperCss = null;

});

parcelRegister("8AQXb", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $8fa89a103bc738eb$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $8fa89a103bc738eb$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    loading: {
        id: 'SoftwareRovoStart.Page.loading',
        defaultMessage: 'Loading'
    },
    login: {
        id: 'SoftwareRovoStart.Page.login',
        defaultMessage: 'Login'
    },
    contactSales: {
        id: 'SoftwareRovoStart.Page.contactSales',
        defaultMessage: 'Contact Sales'
    },
    rovoGetStarted: {
        defaultMessage: 'Get <started>started</started> with Rovo',
        description: 'Title text for WAC Rovo Start_logged out page',
        id: 'SoftwareRovoStart.Page.rovoGetStarted'
    },
    loginButtonRovo: {
        defaultMessage: 'Log in',
        id: 'SoftwareRovoStart.Page.loginButtonRovo'
    },
    rovoBodyText: {
        defaultMessage: 'Log in to add it to your organization',
        id: 'SoftwareRovoStart.Page.rovoBodyText'
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: 'SoftwareRovoStart.Page.dontHaveAccountText'
    },
    contactAtlassianText: {
        defaultMessage: '<a>Contact Atlassian</a>',
        id: 'SoftwareRovoStart.Page.contactAtlassianText'
    },
    errorScreenTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error screen title',
        id: 'SoftwareRovoStart.Page.errorScreenTitle'
    },
    errorScreenMessageOne: {
        defaultMessage: '<a>Contact support</a> for further help or try again.',
        description: 'Error screen message part one',
        id: 'SoftwareRovoStart.Page.errorScreenMessageOne'
    },
    errorScreenMessageTwo: {
        defaultMessage: 'To receive a quote for Rovo, <a>contact sales.</a>',
        description: 'Error screen message part two',
        id: 'SoftwareRovoStart.Page.errorScreenMessageTwo'
    }
});

});

parcelRegister("cxI2Y", function(module, exports) {
$parcel$export(module.exports, "ScribbleImage", function () { return $84c16d41bc354312$export$31b1a25c5f295125; });

var $7VQPk = parcelRequire("7VQPk");
const $84c16d41bc354312$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $84c16d41bc354312$export$31b1a25c5f295125 = $84c16d41bc354312$var$ScribbleImageComponent;

});


parcelRegister("6VYIX", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $6c345910e2c56d86$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");

var $8AQXb = parcelRequire("8AQXb");
const $6c345910e2c56d86$var$loadingCss = null;
const $6c345910e2c56d86$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $8AQXb.messages).loading),
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
};

});


parcelRegister("gsqLc", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", function () { return $88cb943b67e1fe7e$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $6A2DX = parcelRequire("6A2DX");

var $9jghN = parcelRequire("9jghN");
var $7SWbn = parcelRequire("7SWbn");
var $1xo8q = parcelRequire("1xo8q");

var $8AXar = parcelRequire("8AXar");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $fJCnK = parcelRequire("fJCnK");
const $88cb943b67e1fe7e$var$elevatedContainerInnerStyles = (0, $1xo8q.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'space.400',
    alignSelf: 'stretch',
    paddingBlockStart: 'space.150'
});
const $88cb943b67e1fe7e$var$contentStyles = (0, $1xo8q.xcss)({
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'space.200'
});
const $88cb943b67e1fe7e$var$bodyStyles = (0, $1xo8q.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    fontSize: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: '400'
});
const $88cb943b67e1fe7e$var$linkStyles = null;
const $88cb943b67e1fe7e$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    (0, $1oC0p.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'softwareRovoStartPageErrorScreen',
            source: 'softwareRovoStartPage'
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: 'clicked',
            actionSubject: buttonName,
            actionSubjectId: 'softwareRovoStartPageTemplate',
            attributes: {
                source: 'errorScreen'
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSupportLink'), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSalesLink'), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
            xcss: $88cb943b67e1fe7e$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJCnK.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                    xcss: $88cb943b67e1fe7e$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $8AQXb.messages).errorScreenTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                            xcss: $88cb943b67e1fe7e$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jghN.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $8AQXb.messages).errorScreenMessageOne,
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz13af _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jghN.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $8AQXb.messages).errorScreenMessageTwo,
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz13af _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fJCnK", function(module, exports) {
$parcel$export(module.exports, "ErrorIconImage", function () { return $ef9db3692a497100$export$a1922be2c234f039; });

var $7VQPk = parcelRequire("7VQPk");
const $ef9db3692a497100$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $ef9db3692a497100$export$a1922be2c234f039 = $ef9db3692a497100$var$ErrorIconComponent;

});



parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-006a3c900d";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    hasCloudSessionTokenCookie: window.hasCloudSessionTokenCookie,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});


var $hI6CC = parcelRequire("hI6CC");

var $3NQOU = parcelRequire("3NQOU");
(0, $3NQOU.init)((0, $hI6CC.SoftwareRovoStartPage));


//# sourceMappingURL=software-rovo-start-page.a55b9bf6.js.map
